import { Link } from "react-router-dom";
import { Scan, ArrowUpRight } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#0F172A] text-slate-300" data-testid="site-footer">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 pt-20 pb-10">
        <div className="flex flex-col lg:flex-row justify-between gap-12 pb-16 border-b border-slate-800">
          <div>
            <p className="font-display text-5xl sm:text-6xl lg:text-7xl font-extrabold tracking-tighter text-white leading-none mb-6">
              Let&rsquo;s talk.
            </p>
            <a
              href="mailto:hello@x-gen.ai"
              className="inline-flex items-center gap-2 font-mono text-sm tracking-[0.15em] text-sky-400 hover:text-white transition-colors duration-300"
              data-testid="footer-email-link"
            >
              HELLO@X-GEN.AI <ArrowUpRight className="w-4 h-4" />
            </a>
          </div>
          <div className="flex gap-16 font-mono text-xs uppercase tracking-[0.2em]">
            <div className="space-y-3 flex flex-col">
              <span className="text-slate-500 mb-1">Site</span>
              <a href="/#platform" className="hover:text-white transition-colors duration-300" data-testid="footer-link-platform">Platform</a>
              <a href="/#demo" className="hover:text-white transition-colors duration-300" data-testid="footer-link-demo">Demo</a>
              <Link to="/compliance" className="hover:text-white transition-colors duration-300" data-testid="footer-link-compliance">Trust & Compliance</Link>
            </div>
            <div className="space-y-3 flex flex-col">
              <span className="text-slate-500 mb-1">Access</span>
              <Link to="/login" className="hover:text-white transition-colors duration-300" data-testid="footer-link-login">Sign in</Link>
              <Link to="/register" className="hover:text-white transition-colors duration-300" data-testid="footer-link-register">Request access</Link>
              <a href="/#contact" className="hover:text-white transition-colors duration-300" data-testid="footer-link-contact">Contact</a>
            </div>
          </div>
        </div>
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 pt-8">
          <div className="flex items-center gap-2">
            <span className="w-7 h-7 bg-brand rounded-lg flex items-center justify-center">
              <Scan className="w-3.5 h-3.5 text-white" />
            </span>
            <span className="font-display font-extrabold tracking-tight text-white">X-GEN.AI</span>
          </div>
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-slate-500 max-w-md leading-relaxed">
            X-Gen is a clinical decision-support system. Final diagnostic authority always rests with a qualified radiologist.
          </p>
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-slate-500">
            © {new Date().getFullYear()} X-GEN.AI
          </p>
        </div>
      </div>
    </footer>
  );
}
